
















import { Component, Inject } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { ProvidedModalParam } from './types';

@Component({
})
export default class SwModalFooter extends SwExtendedVue {
  @Inject()
  modalParam: ProvidedModalParam;
}
